import { render } from "./FruitsByCategory.vue?vue&type=template&id=02d79060"
import script from "./FruitsByCategory.vue?vue&type=script&lang=js"
export * from "./FruitsByCategory.vue?vue&type=script&lang=js"
script.render = render

export default script